/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TrackingLine } from "./TrackingLine";
import {
  TrackingLineFromJSON,
  TrackingLineFromJSONTyped,
  TrackingLineToJSON,
  TrackingLineToJSONTyped,
} from "./TrackingLine";

/**
 *
 * @export
 * @interface ShipmentTrackingResponse
 */
export interface ShipmentTrackingResponse {
  /**
   *
   * @type {Array<TrackingLine>}
   * @memberof ShipmentTrackingResponse
   */
  lines: Array<TrackingLine>;
}

/**
 * Check if a given object implements the ShipmentTrackingResponse interface.
 */
export function instanceOfShipmentTrackingResponse(
  value: object,
): value is ShipmentTrackingResponse {
  if (!("lines" in value) || value["lines"] === undefined) return false;
  return true;
}

export function ShipmentTrackingResponseFromJSON(
  json: any,
): ShipmentTrackingResponse {
  return ShipmentTrackingResponseFromJSONTyped(json, false);
}

export function ShipmentTrackingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentTrackingResponse {
  if (json == null) {
    return json;
  }
  return {
    lines: (json["lines"] as Array<any>).map(TrackingLineFromJSON),
  };
}

export function ShipmentTrackingResponseToJSON(
  json: any,
): ShipmentTrackingResponse {
  return ShipmentTrackingResponseToJSONTyped(json, false);
}

export function ShipmentTrackingResponseToJSONTyped(
  value?: ShipmentTrackingResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lines: (value["lines"] as Array<any>).map(TrackingLineToJSON),
  };
}
